import {Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {fromEvent, merge, Observable, Observer} from "rxjs";
import {untilDestroyed} from "ngx-take-until-destroy";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-network-unstable',
  templateUrl: './network-unstable.component.html',
  styleUrls: ['./network-unstable.component.css']
})
export class NetworkUnstableComponent implements OnInit, OnDestroy {

  @ViewChild("container", {static: true})
  private containerRef: ElementRef;

  subscription: Observable<any>;

  constructor(private _renderer: Renderer2) {
  }

  ngOnInit(): void {

    this.subscription = merge<boolean>(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    );
    this.subscription
      .pipe(untilDestroyed(this))
      .subscribe(isOnline => {
        console.log('isOnline = ', isOnline);
        let bannerIsShown = this.containerRef.nativeElement.style['display'] == 'block';
        if (!isOnline) {
          if (!bannerIsShown) {
            this._renderer.setStyle(this.containerRef.nativeElement, 'display', 'block');
          }
        } else {
          this._renderer.setStyle(this.containerRef.nativeElement, 'display', 'none');
        }
      });
  }

  ngOnDestroy(): void {

  }

}
